import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { MessageCircleIcon, SendIcon, GiftIcon, ArrowRightIcon, SparklesIcon, TimerIcon, FileTextIcon, SmartphoneIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
function BonusIllustration({
  type
}: {
  type: 'scripts' | 'whatsapp';
}) {
  if (type === 'scripts') {
    return <div className="relative w-full aspect-[4/3] bg-cyber-black rounded-lg overflow-hidden border border-gray-800" data-id="element-18">
        {/* Terminal-style illustration */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(57,255,20,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(57,255,20,0.02)_1px,transparent_1px)] bg-[size:20px_20px]" data-id="element-19"></div>
        <div className="p-4 font-mono text-[10px] leading-relaxed relative z-10" data-id="element-20">
          <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-800" data-id="element-21">
            <div className="w-2 h-2 rounded-full bg-cyber-red" data-id="element-22"></div>
            <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-23"></div>
            <div className="w-2 h-2 rounded-full bg-cyber-neon" data-id="element-24"></div>
            <span className="text-gray-600 ml-2" data-id="element-25">scripts_sociales.sh</span>
          </div>
          <p className="text-gray-600" data-id="element-26">
            <span className="text-cyber-purple" data-id="element-27">$</span>{' '}
            <span className="text-cyber-neon" data-id="element-28">load</span> script_opener_v1
          </p>
          <p className="text-gray-500 mt-1" data-id="element-29">
            <span className="text-gray-700" data-id="element-30">&gt;</span> "Oye, ¿tú también estás
            en la clase de..."
          </p>
          <p className="text-gray-600 mt-2" data-id="element-31">
            <span className="text-cyber-purple" data-id="element-32">$</span>{' '}
            <span className="text-cyber-neon" data-id="element-33">load</span> script_deepener_v3
          </p>
          <p className="text-gray-500 mt-1" data-id="element-34">
            <span className="text-gray-700" data-id="element-35">&gt;</span> "¿Y qué es lo que más te
            gusta de...?"
          </p>
          <p className="text-gray-600 mt-2" data-id="element-36">
            <span className="text-cyber-purple" data-id="element-37">$</span>{' '}
            <span className="text-cyber-neon" data-id="element-38">load</span> script_exit_v2
          </p>
          <p className="text-gray-500 mt-1" data-id="element-39">
            <span className="text-gray-700" data-id="element-40">&gt;</span> "Fue genial hablar
            contigo, te escribo..."
          </p>
          <motion.div animate={{
          opacity: [1, 0, 1]
        }} transition={{
          duration: 1,
          repeat: Infinity
        }} className="inline-block w-2 h-3 bg-cyber-neon mt-2" data-id="element-41" />
        </div>
        {/* Glow */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-8 bg-cyber-neon/10 blur-xl" data-id="element-42"></div>
      </div>;
  }
  return <div className="relative w-full aspect-[4/3] bg-cyber-black rounded-lg overflow-hidden border border-gray-800" data-id="element-43">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(57,255,20,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(57,255,20,0.02)_1px,transparent_1px)] bg-[size:20px_20px]" data-id="element-44"></div>
      <div className="p-4 font-mono text-[10px] leading-relaxed relative z-10" data-id="element-45">
        {/* Phone mockup */}
        <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-800" data-id="element-46">
          <SmartphoneIcon className="w-3 h-3 text-cyber-neon" data-id="element-47" />
          <span className="text-gray-600" data-id="element-48">whatsapp_masterclass.dm</span>
        </div>
        {/* Chat bubbles */}
        <div className="space-y-2" data-id="element-49">
          <div className="flex justify-end" data-id="element-50">
            <div className="bg-cyber-neon/15 border border-cyber-neon/30 rounded-lg rounded-tr-none px-2 py-1 max-w-[75%]" data-id="element-51">
              <p className="text-gray-400" data-id="element-52">Vi tu historia del concierto</p>
              <p className="text-gray-400" data-id="element-53">¿Quién tocó mejor? 🎸</p>
            </div>
          </div>
          <div className="flex justify-start" data-id="element-54">
            <div className="bg-gray-800/50 border border-gray-700 rounded-lg rounded-tl-none px-2 py-1 max-w-[75%]" data-id="element-55">
              <p className="text-gray-400" data-id="element-56">Jajaja sin duda la banda de...</p>
              <p className="text-gray-400" data-id="element-57">¿Tú también fuiste?!</p>
            </div>
          </div>
          <div className="flex justify-end" data-id="element-58">
            <div className="bg-cyber-neon/15 border border-cyber-neon/30 rounded-lg rounded-tr-none px-2 py-1 max-w-[75%]" data-id="element-59">
              <p className="text-gray-400" data-id="element-60">Sí! Deberíamos ir al próximo</p>
            </div>
          </div>
          <div className="flex justify-start" data-id="element-61">
            <div className="bg-gray-800/50 border border-gray-700 rounded-lg rounded-tl-none px-2 py-1" data-id="element-62">
              <p className="text-cyber-neon" data-id="element-63">Dale, me apunto</p>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-8 bg-cyber-neon/10 blur-xl" data-id="element-64"></div>
    </div>;
}
export function BonusSection() {
  const [minutesLeft, setMinutesLeft] = useState(10);
  const [secondsLeft, setSecondsLeft] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev === 0) {
          if (minutesLeft === 0) {
            clearInterval(timer);
            return 0;
          }
          setMinutesLeft(m => m - 1);
          return 59;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [minutesLeft]);
  const formattedTime = `${minutesLeft.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`;
  return <SectionWrapper id="bonos" className="bg-[#0d0d0d] border-y border-cyber-neon/10" data-id="element-65">
      <div className="text-center mb-12" data-id="element-66">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-cyber-neon/40 bg-cyber-neon/5 text-cyber-neon font-mono text-xs mb-6" data-id="element-67">
          <GiftIcon className="w-3.5 h-3.5" data-id="element-68" />
          <span data-id="element-69">BONOS EXCLUSIVOS DE LANZAMIENTO</span>
        </div>

        <h2 className="text-2xl md:text-4xl text-white font-mono font-bold mb-4" data-id="element-70">
          Lleva el sistema completo,{' '}
          <span className="text-cyber-neon text-shadow-neon" data-id="element-71">
            no solo el libro.
          </span>
        </h2>

        <p className="text-gray-400 max-w-2xl mx-auto leading-relaxed" data-id="element-72">
          Si ordenas en los próximos{' '}
          <span className="text-cyber-neon font-mono font-bold bg-cyber-neon/10 px-2 py-0.5 rounded border border-cyber-neon/30" data-id="element-73">
            {formattedTime}
          </span>{' '}
          minutos, incluimos estos 2 recursos tácticos valorados en{' '}
          <span className="text-white font-bold" data-id="element-74">$47 USD</span> totalmente{' '}
          <span className="text-cyber-neon font-bold uppercase" data-id="element-75">GRATIS</span>.
        </p>
      </div>

      {/* 2-Column Bonus Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-76">
        {/* Card 1: Scripts */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-cyber-dark border border-cyber-neon/40 rounded-xl overflow-hidden relative group hover:border-cyber-neon hover:shadow-neon transition-all duration-500" data-id="element-77">
          {/* REGALO GRATIS Badge */}
          <div className="absolute top-4 right-4 z-20 flex items-center gap-1.5 bg-cyber-neon text-cyber-black font-mono font-bold text-[10px] px-3 py-1.5 rounded-full shadow-neon" data-id="element-78">
            <GiftIcon className="w-3 h-3" data-id="element-79" />
            REGALO GRATIS
          </div>

          {/* Bonus Image */}
          <div className="p-4 pb-0" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/rFpEPMjSoTV2TwFp854aUL/Bono_1.png" alt="Bono #1: Scripts Muerte al Grillo" className="w-full h-auto rounded-lg" data-id="element-81" />
          </div>

          <div className="p-5" data-id="element-82">
            <div className="flex items-center gap-2 mb-3" data-id="element-83">
              <div className="w-8 h-8 rounded-lg bg-cyber-neon/10 border border-cyber-neon/30 flex items-center justify-center" data-id="element-84">
                <MessageCircleIcon className="w-4 h-4 text-cyber-neon" data-id="element-85" />
              </div>
              <h3 className="text-white font-mono font-bold text-sm" data-id="element-86">
                BONO #1: SCRIPTS MUERTE AL GRILLO
              </h3>
            </div>

            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-87">
              Qué decir exactamente después del "Hola" para que la plática fluya
              sola. Nunca más te quedes en blanco.
            </p>

            <div className="flex items-center gap-3 pt-3 border-t border-gray-800" data-id="element-88">
              <span className="text-gray-600 line-through text-sm font-mono" data-id="element-89">
                $25 USD
              </span>
              <span className="text-cyber-neon font-bold font-mono text-lg" data-id="element-90">
                $0.00
              </span>
              <SparklesIcon className="w-4 h-4 text-cyber-neon" data-id="element-91" />
            </div>
          </div>
        </motion.div>

        {/* Card 2: WhatsApp/DM */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="bg-cyber-dark border border-cyber-neon/40 rounded-xl overflow-hidden relative group hover:border-cyber-neon hover:shadow-neon transition-all duration-500" data-id="element-92">
          {/* REGALO GRATIS Badge */}
          <div className="absolute top-4 right-4 z-20 flex items-center gap-1.5 bg-cyber-neon text-cyber-black font-mono font-bold text-[10px] px-3 py-1.5 rounded-full shadow-neon" data-id="element-93">
            <GiftIcon className="w-3 h-3" data-id="element-94" />
            REGALO GRATIS
          </div>

          {/* Bonus Image */}
          <div className="p-4 pb-0" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/iZmzqtZXpXdgptxAXMURcs/Bono_2.png" alt="Bono #2: El Fin del Vista" className="w-full h-auto rounded-lg" data-id="element-96" />
          </div>

          <div className="p-5" data-id="element-97">
            <div className="flex items-center gap-2 mb-3" data-id="element-98">
              <div className="w-8 h-8 rounded-lg bg-cyber-neon/10 border border-cyber-neon/30 flex items-center justify-center" data-id="element-99">
                <SendIcon className="w-4 h-4 text-cyber-neon" data-id="element-100" />
              </div>
              <h3 className="text-white font-mono font-bold text-sm" data-id="element-101">
                BONO #2: EL FIN DEL VISTA
              </h3>
            </div>

            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-102">
              Cómo responder historias y enviar DMs que generen una respuesta
              inmediata sin parecer intenso.
            </p>

            <div className="flex items-center gap-3 pt-3 border-t border-gray-800" data-id="element-103">
              <span className="text-gray-600 line-through text-sm font-mono" data-id="element-104">
                $22 USD
              </span>
              <span className="text-cyber-neon font-bold font-mono text-lg" data-id="element-105">
                $0.00
              </span>
              <SparklesIcon className="w-4 h-4 text-cyber-neon" data-id="element-106" />
            </div>
          </div>
        </motion.div>
      </div>

      {/* Summary Pricing Box */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-cyber-black border-2 border-cyber-neon rounded-2xl p-6 md:p-8 text-center relative overflow-hidden shadow-neon" data-id="element-107">
        <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.2)_50%)] bg-[length:100%_4px] pointer-events-none opacity-10" data-id="element-108"></div>

        <div className="relative z-10" data-id="element-109">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-110">
            <FileTextIcon className="w-5 h-5 text-gray-500" data-id="element-111" />
            <span className="text-gray-400 font-mono text-sm" data-id="element-112">
              Ebook + Bono #1 + Bono #2
            </span>
          </div>

          <div className="mb-2" data-id="element-113">
            <span className="text-gray-500 font-mono text-xl line-through decoration-cyber-red decoration-2" data-id="element-114">
              Valor Total: $121 USD
            </span>
          </div>

          <div className="mb-1" data-id="element-115">
            <span className="text-gray-600 font-mono text-xs uppercase tracking-widest" data-id="element-116">
              Precio Especial
            </span>
          </div>

          <motion.div animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity
        }} className="mb-6" data-id="element-117">
            <h3 className="text-5xl md:text-7xl font-bold font-mono text-cyber-neon text-shadow-neon-strong" data-id="element-118">
              $9.99 <span className="text-xl text-cyber-neon/60" data-id="element-119">USD</span>
            </h3>
          </motion.div>

          <motion.div animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-120">
            <NeonButton size="lg" fullWidth href={CHECKOUT_URL} className="text-base md:text-xl py-5 max-w-lg mx-auto" data-id="element-121">
              <SparklesIcon className="w-5 h-5" data-id="element-122" />
              SI, QUIERO EL PACK CON LOS BONOS GRATIS
              <ArrowRightIcon className="w-5 h-5" data-id="element-123" />
            </NeonButton>
          </motion.div>

          <div className="mt-4 flex items-center justify-center gap-2 text-gray-500 font-mono text-xs" data-id="element-124">
            <TimerIcon className="w-3.5 h-3.5 text-cyber-red" data-id="element-125" />
            <span data-id="element-126">
              Bonos disponibles solo por los próximos{' '}
              <span className="text-cyber-neon font-bold" data-id="element-127">{formattedTime}</span>
            </span>
          </div>
        </div>
      </motion.div>
    </SectionWrapper>;
}